export default __webpack_public_path__ + "static/media/rejected.e8b3c853.gif";